import { FC } from 'react';
import { compose } from 'redux';
import InformativeMessage, { InformativeMessageProps } from './InformativeMessage';

export default compose<FC<InformativeMessageProps>>()(InformativeMessage);
